import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import FilterWrapper from './FilterWrapper';
import useScrollIntoView from './useScrollIntoView';
import Popup from '../Common/Popup';

/**
 * The `AcquirerTypeFilter` function is a React component that renders a dropdown filter for selecting
 * an acquirer company type.
 * @returns a JSX element.
 */
function AcquirerTypeFilter({ setAcquirerTypeOptions, AcquirerTypeOptions, customPathname, label = "Acquirer Company Type", isPopupOpen, setIsPopupOpen }) {
    const { companyType, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const Ids = refineSearchFilters[customPathname]?.acquirerType?.map(value => value.id) ?? [];
        setAcquirerTypeOptions(companyType?.map(industry => ({ ...industry, isChecked: Ids.includes(industry.id) })))
    }, [companyType, customPathname, refineSearchFilters, setAcquirerTypeOptions])


  /**
   * The function `handleCompanyTypeChange` updates the `isChecked` property of each object in the
   * `AcquirerTypeOptions` array based on the selected value from the event target.
   * @param e - The parameter `e` is an event object that is passed to the `handleCompanyTypeChange`
   * function. It is typically an event object that is triggered by a user action, such as clicking a
   * button or changing the value of an input field.
   */
    const handleCompanyTypeChange = (e) => {
        const value = e.target.value
        setAcquirerTypeOptions(AcquirerTypeOptions?.map(type => ({ ...type, isChecked: value === "" ? false : type.id === value })))
    }

    const selectedAcquirerType = AcquirerTypeOptions?.filter(option => option.isChecked)?.at(0)

    const getDisplayText = () => {
        return selectedAcquirerType?.name || "Select type";
    };

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {companyType.slice(0,2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedAcquirerType && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {getDisplayText()}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <div>
                            {/* <label className="block text-sm font-medium text-gray-700 mb-2">
                                Select Acquirer Company Type
                            </label> */}
                            <div className="space-y-2">
                                <div className="max-h-60 overflow-y-auto grid grid-cols-3">
                                    <label className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                        <input
                                            type="radio"
                                            name="acquirerType"
                                            value=""
                                            checked={!selectedAcquirerType}
                                            onChange={handleCompanyTypeChange}
                                            className="text-[#D9BD7F] focus:ring-[#D9BD7F]"
                                        />
                                        <span className="text-[13px]">All</span>
                                    </label>
                                    {AcquirerTypeOptions && AcquirerTypeOptions.length > 0 ? (
                                        AcquirerTypeOptions.map((companyType, index) => (
                                            <label key={companyType.id} className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                                <input
                                                    type="radio"
                                                    name="acquirerType"
                                                    value={companyType.id}
                                                    checked={selectedAcquirerType?.id === companyType.id}
                                                    onChange={handleCompanyTypeChange}
                                                    className="text-[#D9BD7F] focus:ring-[#D9BD7F]"
                                                />
                                                <span className="text-[13px]">{companyType.name}</span>
                                            </label>
                                        ))
                                    ) : (
                                        <div className="text-sm text-gray-500 p-2">No results found!</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default AcquirerTypeFilter